/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import ClientKyc from "./NewClientKyc";

export default ClientKyc;
